import { render } from "./HomeView.vue?vue&type=template&id=31cf5e8b"
const script = {}

import exportComponent from "D:\\a\\r1\\a\\_PositioningServiceWebapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__